import { Grid } from "@mui/material";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { LoadKafkaOrg, LoadOrganizations } from '../../actions';
import setToast from '../../helpers/toaster.helper';
import { AddKafkaIcon, EditIcon } from '../../icon';
import { KafkaModel } from '../../models/kafka.model';
import { OrganizationModel } from '../../models/organization.model';
import * as selector from "../../selectors/selectors";
import { KafkaService } from '../../services/KakfaServies';
import ButtonComponent from '../shared/button/button.component';
import { buttonLabels } from '../shared/constants';
import GridOptions from "../shared/grid-options.component";
import PageHeaderComponent from '../shared/page-header.component';
import { ToasterType } from '../shared/toaster/toaster.model';
import AddKafkaComponent from './add-kafka.component';
import { orgSelectedInOtherGroups } from './kafka.utils';

interface IProps { }

const KafkaComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const Organizations: OrganizationModel[] = useSelector(selector.organizations)
    const Kafka: KafkaModel[] = useSelector(selector.kafka)
    const [IsLoading, SetIsLoading] = useState<boolean>(false);
    const [ShowAddKafkaForm, setShowAddKafkaForm] = useState<boolean>(false)
    const [selectedRow, setSelectedRow] = useState<KafkaModel | undefined>(undefined)


    const getGridTitle = () => {
        return ""
    }

    const globalSearch = (e: any) => {

    };

    const addKafkaka = (value?: KafkaModel) => {
        setShowAddKafkaForm(true);
        setSelectedRow(value)
    }

    const closeKafka = (isConfirm: boolean) => {
        setShowAddKafkaForm(false)
    };

    useEffect(() => {
        LoadKafkaOrg(dispatch);
        LoadOrganizations(dispatch);
    }, [])

    const formSubmit = (event: any) => {
        event.preventDefault();
        SetIsLoading(true);
        const data = Kafka.map((kafka) => ({
            "groupId": kafka.GroupId,
            "organizations": kafka.Organizations.map(x => ({
                "id": x.ID,
                "name": x.Name,
                "isDeleted": x.IsDeleted
            }))
        }));

        KafkaService.AssignGroups(data)
            .then(() => {
                SetIsLoading(false);
                LoadKafkaOrg(dispatch)
            })
            .catch((err) => {
                setToast(err.response.data.message, ToasterType.DANGER)
                SetIsLoading(false);
            });

    }
    const AdminOrganizations = Organizations?.filter(x => x.Name !== "Admin");
    const unmappedOrgs = AdminOrganizations.filter((x) => !orgSelectedInOtherGroups(x, Kafka));
    const unAssignedOrgs = Kafka?.find(x => x.GroupId === -1)?.Organizations.length;

    return (
        <>
            <PageHeaderComponent
                Reload={() => { }}
                GridTitle={getGridTitle()}
                Actions={
                    [
                        {
                            OnClick: () => addKafkaka(),
                            ButtonLabel: buttonLabels.ADD_KAFKA_CLUSTER,
                            Icon: AddKafkaIcon,
                            ClassName: "mr-2",
                            Variant: "primary-btn",
                        },
                    ]}
                ShowFilterIcon={false}
                onSearch={globalSearch}
                PlaceHolder={"Find..."}
                HideSearch={true}
            />
            <div className='d-flex pl-4'>
                <div className='bg-color-settings-text-field-background p-1 color-display-content h4-regular br-1'>Total Active Organizations:<span className='h4-semibold pl-1'>{AdminOrganizations.length}</span></div>
                <div className='bg-color-settings-text-field-background mx-1 p-1 color-display-content h4-regular br-1'>Total Unmapped Organizations:<span className='h4-semibold pl-1'>{unmappedOrgs.length}</span></div>
            </div>
            <Grid container style={{ height: "calc(100% - 22vh)" }} className='bg-color-grid o-y-scroll m-2 p-2 d-flex flex-warp w-fill m-auto'>
                <Grid container className='' item xs={12}>
                    {Kafka?.map(x =>
                        <Grid item xs={4}>
                            <div className='card-body'>
                                <div className="p-relative h-p-100">
                                    <div className='p-2 h2-semibold'>{x.GroupId === -1 ? "Unassigned" : x.GroupId === 0 ? "Default Group" : `Group ${x.GroupId}`}</div>
                                    <div className='bg-color-secondary-btn-highlight-hover h-p-65 mx-2'>
                                        <div className='h5-semibold px-2 py-1'> Organization -{x.Organizations.filter(y => y.Name !== "Admin").length}</div>
                                        <div className=''>  <div className='kafka-border ml-2 mr-3'></div></div>
                                        <div className='o-y-scroll h-p-75 px-2'>{x.Organizations.filter(y => y.Name !== "Admin").map(z => <div className='h5-regular py-1 color-tags-title'> {z.Name} </div>)}</div></div>
                                    <div className='p-absolute r-1 t-1'>
                                        <GridOptions
                                            data={
                                                [
                                                    {
                                                        btnName: "Edit",
                                                        btnColor: "primary",
                                                        onClickbtn: () => addKafkaka(x),
                                                        btnIcon: EditIcon
                                                    },

                                                ]}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    )}</Grid>

                <div className='ml-auto d-flex align-end py-2'>
                    <ButtonComponent OnClick={() => LoadKafkaOrg(dispatch)} ButtonLabel={buttonLabels.CANCEL} ClassName={"mr-1 ml-auto"} Variant={"secondary-btn-small"} />
                    <ButtonComponent OnClick={(e) => formSubmit(e)} Type={"button"} ButtonLabel={"Assign"} ClassName={"px-4 mr-1"} Variant={unmappedOrgs.length || unAssignedOrgs ? "disabled-btn-small" : "primary-btn-small"} Loading={IsLoading} />
                </div>

            </Grid>

            {
                ShowAddKafkaForm && <AddKafkaComponent
                    Show={ShowAddKafkaForm}
                    CloseKafkaForm={closeKafka}
                    KafkaData={selectedRow} />
            }
        </>
    )
}

export default KafkaComponent;


